// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconPensionPath = 'M10.015 17.918a7.83 7.83 0 0 1-2.335-.374 14.077 14.077 0 0 0 2.336-4.26 14.061 14.061 0 0 0 2.325 4.245c-.63.2-1.448.387-2.326.389Zm3.794-13.584a5.66 5.66 0 0 0-2.658.837c-.095-.717.165-1.46.774-2.061.97-.955 2.534-1.296 3.889-.852l.623-1.901c-2.05-.67-4.43-.138-5.916 1.33-.194.19-.366.392-.521.6a5.029 5.029 0 0 0-.52-.6C7.994.219 5.615-.314 3.563.357l.623 1.9c1.356-.443 2.92-.102 3.89.853.609.6.869 1.344.774 2.06a5.662 5.662 0 0 0-2.657-.836C4 4.198 2.01 5.302 1.18 7.047l1.805.859c.486-1.02 1.72-1.65 3.095-1.576 1.345.076 2.492.825 2.873 1.87-.225 3.767-1.447 6.798-3.66 9.01l-.911.912 1.109.656c.078.046 1.937 1.13 4.509 1.14h.032c2.425-.01 4.398-1.078 4.48-1.124l1.169-.642-.942-.941c-2.226-2.226-3.448-5.28-3.662-9.074.404-1.011 1.527-1.733 2.844-1.807 1.344-.075 2.608.556 3.095 1.576l1.805-.86c-.832-1.744-2.863-2.846-5.012-2.712Z';
var IconPension = baseIcon('IconPension', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconPensionPath
});
export default IconPension;
//# sourceMappingURL=index.js.map